var map = {
	"./circular/ar.svg": "a5f0",
	"./circular/de.svg": "6505",
	"./circular/en.svg": "1664",
	"./circular/es.svg": "dc38",
	"./circular/fa.svg": "16e6",
	"./circular/fr.svg": "84d1",
	"./circular/it.svg": "c2c0",
	"./circular/ja.svg": "0d0d",
	"./circular/ko.svg": "6ed0",
	"./circular/pt.svg": "981b",
	"./circular/ru.svg": "36b5",
	"./circular/tr.svg": "172c",
	"./circular/us.svg": "b0d6",
	"./circular/zh.svg": "4b8c",
	"./linear/ar.svg": "332c",
	"./linear/de.svg": "c5d6",
	"./linear/en.svg": "9bb6",
	"./linear/es.svg": "6618",
	"./linear/fa.svg": "621f",
	"./linear/fr.svg": "14a1",
	"./linear/it.svg": "a508",
	"./linear/ja.svg": "06d9",
	"./linear/ko.svg": "e3bd",
	"./linear/pt.svg": "a90d",
	"./linear/ru.svg": "24a1",
	"./linear/tr.svg": "9d92",
	"./linear/us.svg": "99e6",
	"./linear/zh.svg": "162d",
	"./simple-radius/ar.svg": "7c5e",
	"./simple-radius/de.svg": "a98d",
	"./simple-radius/en.svg": "efea",
	"./simple-radius/es.svg": "4093",
	"./simple-radius/fa.svg": "79f2",
	"./simple-radius/fr.svg": "08d8",
	"./simple-radius/it.svg": "e65a",
	"./simple-radius/ja.svg": "fa9b",
	"./simple-radius/ko.svg": "8b5a",
	"./simple-radius/pt.svg": "2265",
	"./simple-radius/ru.svg": "c65c",
	"./simple-radius/tr.svg": "baf1",
	"./simple-radius/us.svg": "b21c",
	"./simple-radius/zh.svg": "f8c9",
	"./simple/ar.svg": "480d",
	"./simple/de.svg": "536e",
	"./simple/en.svg": "c646",
	"./simple/es.svg": "774b",
	"./simple/fa.svg": "6d64",
	"./simple/fr.svg": "8cf7",
	"./simple/it.svg": "c648",
	"./simple/ja.svg": "1c99",
	"./simple/ko.svg": "3f63",
	"./simple/pt.svg": "00af",
	"./simple/ru.svg": "fa89",
	"./simple/tr.svg": "cabd",
	"./simple/us.svg": "fa75",
	"./simple/zh.svg": "66f9",
	"./square/ar.svg": "945b",
	"./square/de.svg": "7e57",
	"./square/en.svg": "85f9",
	"./square/es.svg": "0b2d",
	"./square/fa.svg": "fc5b",
	"./square/fr.svg": "6b5a",
	"./square/it.svg": "61df",
	"./square/ja.svg": "41b9",
	"./square/ko.svg": "d298",
	"./square/pt.svg": "8353",
	"./square/ru.svg": "d19a",
	"./square/tr.svg": "8e7e",
	"./square/us.svg": "2abc",
	"./square/zh.svg": "3061"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a15a";